var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4529_28089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 44C71 56.7025 60.7025 67 48 67C35.2975 67 25 56.7025 25 44C25 31.2975 35.2975 21 48 21C60.7025 21 71 31.2975 71 44ZM29.6 44C29.6 54.162 37.838 62.4 48 62.4C58.162 62.4 66.4 54.162 66.4 44C66.4 33.838 58.162 25.6 48 25.6C37.838 25.6 29.6 33.838 29.6 44Z",
    fill: "#30C48F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 44,
    r: 19,
    fill: "#30C48F",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4529_28089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6967 39.6275L54.7061 39.6183L51.6893 36.6942C51.415 36.4283 50.9611 36.4283 50.6868 36.6942C50.4126 36.96 50.4126 37.4 50.6868 37.6658L52.1811 39.1142C51.1881 39.4808 50.5166 40.4617 50.6868 41.5983C50.8382 42.6067 51.7271 43.4225 52.7674 43.5325C53.2119 43.5783 53.5997 43.505 53.9685 43.3492V49.9583C53.9685 50.4625 53.5429 50.875 53.0228 50.875C52.5026 50.875 52.077 50.4625 52.077 49.9583V45.8333C52.077 44.825 51.2259 44 50.1856 44H49.2399V37.5833C49.2399 36.575 48.3887 35.75 47.3485 35.75H41.6742C40.6339 35.75 39.7827 36.575 39.7827 37.5833V51.3333C39.7827 51.8375 40.2083 52.25 40.7284 52.25H48.2942C48.8143 52.25 49.2399 51.8375 49.2399 51.3333V45.375H50.6585V49.83C50.6585 51.0308 51.5474 52.1217 52.7769 52.2408C54.1955 52.3783 55.3871 51.3058 55.3871 49.9583V41.25C55.3871 40.6175 55.1223 40.04 54.6967 39.6275ZM53.0228 42.1667C52.5026 42.1667 52.077 41.7542 52.077 41.25C52.077 40.7458 52.5026 40.3333 53.0228 40.3333C53.5429 40.3333 53.9685 40.7458 53.9685 41.25C53.9685 41.7542 53.5429 42.1667 53.0228 42.1667ZM43.5656 47.7767V45.375H42.4591C42.0997 45.375 41.8728 45.0083 42.043 44.6967L44.568 40.1133C44.795 39.7008 45.457 39.8567 45.457 40.3333V43.0833H46.5351C46.8945 43.0833 47.1215 43.4592 46.9418 43.7708L44.4451 48.0058C44.2087 48.4092 43.5656 48.2442 43.5656 47.7767Z",
    fill: "#FAFAFB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4529_28089",
    x: 0,
    y: 0.5,
    width: 95.5,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.92549 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4529_28089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4529_28089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4529_28089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6972,
    height: 22,
    fill: "white",
    transform: "translate(36 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableIcon);
export default __webpack_public_path__ + "static/media/availableIcon.9a8aba23f36d4a6ff11b9fd2b8ae82e0.svg";
export { ForwardRef as ReactComponent };